import React from 'react';
import {
  ReactTable,
  notALink,
  rtTable,
  rtThead,
  rtTbody,
  rtTr,
  rtTrGroup,
  rtTh,
  rtTd,
} from './ReactTable.module.css';

export const ProgramSearchResults = ({ search, results, setFieldValue, hideSearch }) => {
  // Only return null if the search string is empty.
  // If search has a value but results are 0, render the "no match" message.
  if (search === '') return null;

  if (results.length === 0) {
    return (
      <div>
        <p>
          Your search term <b>{search}</b> does not match any programs.
        </p>
      </div>
    );
  }

  const handleSelect = (row) => {
    setFieldValue('hhs_program', row.programKey, false);
    if (row.programKey === 'OS') {
      setFieldValue('office_of_secretary', row.officeKey, false);
    }
    setFieldValue('business_unit', row.bizunitKey, false);
    hideSearch();
  };

  return (
    <div className={ReactTable}>
      <div className={rtTable} role="grid">
        {/* Header */}
        <div className={rtThead} style={{ background: 'none' }}>
          <div className={rtTr} role="row">
            <div className={rtTh}>Program</div>
            {/* Restore original capitalization to match snapshots */}
            <div className={rtTh}>Office of Secretary</div>
            <div className={rtTh}>Business Unit</div>
            <div className={rtTh}>Select</div>
          </div>
        </div>

        {/* Body */}
        <div className={rtTbody}>
          {results.map((row, idx) => (
            <div className={rtTrGroup} key={idx}>
              <div className={rtTr} role="row">
                <div className={rtTd} role="gridcell" data-col="program">
                  {row.program}
                </div>
                <div className={rtTd} role="gridcell" data-col="office">
                  {row.office || ''}
                </div>
                <div className={rtTd} role="gridcell" data-col="bizunit">
                  {row.bizunit}
                </div>
                <div className={rtTd} role="gridcell">
                  <a
                    href="#select"
                    className={notALink}
                    onClick={(e) => {
                      e.preventDefault();
                      handleSelect(row);
                    }}
                  >
                    Select
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
